<script setup lang="ts">
defineProps<{
	modelValue: 'km' | 'mi'
}>()

const emit = defineEmits<{
	'update:modelValue': [value: 'km' | 'mi']
}>()
</script>

<template>
	<div class="unit-toggle">
		<button :class="{ active: modelValue === 'km' }" @click="emit('update:modelValue', 'km')">km</button>
		<button :class="{ active: modelValue === 'mi' }" @click="emit('update:modelValue', 'mi')">mi</button>
	</div>
</template>

<style scoped>
.unit-toggle {
	display: flex;
	gap: 0;
	border-radius: 4px;
	overflow: hidden;
	width: fit-content;
	flex: 0 0 auto;
}

.unit-toggle button {
	padding: 0.4rem 0.6rem;
	border: none;
	background: #eaeaea;
	color: #333;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	font-size: 0.8rem;
	font-family: unset;
}

.unit-toggle button:first-child {
	border-radius: 4px 0 0 4px;
}

.unit-toggle button:last-child {
	border-radius: 0 4px 4px 0;
}

.unit-toggle button:hover:not(.active) {
	background: #ddd;
}

.unit-toggle button.active {
	background: #333;
	color: white;
}
</style>
